import React, { useEffect, useState } from "react";
import GiftcardForm from "./GiftcardForm";
import NavLanguage from "./components/ui/navLanguage";
import { loadTranslations, strings } from "./assets/config/translations";

const App = ({ path, market, language }) => {
  const [translations, setTranslations] = useState({});
  const [selectedLanguage, setSelectedLanguage] = useState(language);

  const handleLanguageChange = (newLanguage) => {
    loadTranslations(newLanguage)
      .then(() => {
        setTranslations(strings);
        setSelectedLanguage(newLanguage);
      })
      .catch((error) => console.error("Failed to load translations", error));
  };

  useEffect(() => {
    loadTranslations(language)
      .then(() => {
        setTranslations(strings);
        setSelectedLanguage(language); 
      })
      .catch((error) => console.error("Failed to load translations", error));
  }, [language]);

  return (
    <div>
      <NavLanguage
        market={market}
        currentLanguage={selectedLanguage}
        onLanguageChange={handleLanguageChange}
      />
      <GiftcardForm path={path} market={market} language={selectedLanguage} />
    </div>
  );
};

export default App;
